import Header from '../../../__Layout/Header';
import React from "react";
import Loader from '../../../utils/Loader';
import { useResultDetailQuery,useSubmitMockExamMarksMutation } from "../../../Services/api";
import {useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
export default function UserResultDetail() {
    const { user_id } = useParams();
    const {
        data: resultDetail,
        isLoading: isGetLoading,
      } = useResultDetailQuery({ params: user_id});
    const validationSchema = Yup.object().shape({
        //  course_id: Yup.string().required("course_id fields is required"),
    });
    let defaultValues = {lqrd_id:'' };
    const notify = () => '';
    const methods = useForm({
      mode: "onTouched",
      resolver: yupResolver(validationSchema),
      defaultValues,
    });
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = methods;
    const [SubmitMockExamMarks,isLoading] = useSubmitMockExamMarksMutation();
    const onSubmit = (values,e) => {
        SubmitMockExamMarks({ data: values })
        .unwrap()
        .then((payload) => {
            if (payload.status) {
                e.target.reset()
                toast.success(payload.message)
            } else {
                toast.error(payload.message)
            }
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
        notify();
    };
     
      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Mock Exam List</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Mock Exam List </button>
                        </li>
                      
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                            <div className="row">
                                   <div className='col-12'>
                                   <form onSubmit={handleSubmit(onSubmit)} >
                                       
                                        {resultDetail?.data?.map((item,index) => { 
                                             return (                                 
                                                 <div key={index}>
                                                    <div className='row mb-4'>
                                                        <div className='col-1'></div>
                                                        <div className='col-10 '>
                                                            <input type="hidden" {...register('lqs_id')} value={item.lqs_id}  />
                                                            <input type="hidden" {...register('user_id')} value={item.user_id} />
                                                           <p className='text-warning'>{item?.long_question?.title}</p>
                                                           Student Answer : <p className='text-dark'>{item?.answer}</p>
                                                           <input type="hidden" {...register(`quiz[question][${index}]`)} value={item.lqrd_id} />
                                                           Marks:<input type="number" {...register(`quiz[marks][${index}]`)}  />
                                                        </div>
                                                        <div className='col-1'></div>
                                                    </div> 
                                                 </div>
                                             )  
                                            })  
                                         }
                      
                                        <div className="row mb-3">
                                            
                                            <div className="col-sm-4 pull-right">
                                                    {isLoading.status !='pending' ? 
                                                                
                                                    <button type="submit" className="btn btn-warning w-100" >Submit Marks</button>
                                                    :
                                                    <button className="btn btn-warning w-100" ><div className="spinner-border text-muted"></div></button>
                                                    }
                                            </div>
                                        </div>
                                    </form>
                                   </div>
                                </div>
                            </section>  
                        </div>
                        
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
